require('./scss/app.scss')

// Travlr Uikit Default
// Will import all components Javascript of TravlrUikit
require('./travlruikit')

// Example For Customize TravlrUikit
// import Button from './js/button'
// import Modal from './js/modal'
// import TravlrUikit from './travlruikit'

// new TravlrUikit({
//   button: Button,
//   modal: Modal
// })

export default {
  //
}
